export default __webpack_public_path__ + "static/media/cert-fsi-cpttm.2654ed8d.jpg";